export default {
  leftPanel: {
    title: "为何要加入我们？",
    paragraph1: "我们在全球范围内寻找顶尖精英人才。",
    paragraph2:
      "只要你敢想敢做，超导就是你实现梦想的舞台，在这里你可以尽情彰显个性，释放激情。",
    paragraph3: "只要你是牛人，只要你对梦想有所执着，超导就是你的归属。",
    paragraph4: "邮箱（招聘）：hr{'@'}shsctec.com",
  },

  jobs: {
    salesSpecialist: {
      title: "销售专员",
      details: `岗位职责：
---1.投标工作
---独立完成标书制作，确保中标率。
---与团队配合，优化标书内容，提升竞争力。
---2.客户关系维护
---快速响应客户需求，处理紧急情况。
---提供全方位服务，提升客户满意度。
---3.内部流程优化
---参与公司制度完善与执行，提出建议。
---协助文档整理、审计等工作，确保流程合规。
---4.订单执行管理
---在 ERP 系统中准确录入订单信息，全程跟踪订单执行。配合各部门，保障业务流程顺畅。
---5.客户开发
---积极寻找潜在客户，通过市场调研、行业展会、网络平台等方式拓展客户资源。
---制定客户开发计划，定期拜访潜在客户，了解客户需求，寻找合作机会。与潜在客户建立良好沟通，介绍公司产品和服务优势，促成合作意向。跟踪潜在客户转化情况，及时反馈客户开发进度，为公司业务拓展提供支持。

---任职资格：
---1.具备出色的沟通技巧和商务谈判能力。
---2.能够独立处理销售过程，具有良好的问题解决能力。
---3.积极主动，对销售工作充满热情。`,
    },
    testEngineer: {
      title: "测试工程师（研发岗）",
      details: `岗位职责：
---1.负责对超导带材，超导线圈、超导接头进行综合性能测试分析；
---2.对材料进行性能测试和分析，以确保材料能够满足工业应用的需求；
---3.跟踪调研各科研单位及企业对材料的应用情况；
---4.熟练掌握负责各检测设备和表征设备的操作；
---5.负责高温超导材料性能表征与优化；
---任职资格
---1.物理、化学、材料、电气等相关专业，电气优先；
---2.动手能力强，有超导材料相关工作经验者优先考虑 ；
---3.具有较强的观察能力和分析能力，熟悉各类测试设备和数据处理软件；
---4.工作认真负责、严谨细致、有良好的团队意识和沟通能力。`,
    },
    rdEngineer: {
      title: "研发工程师（研发岗）",
      details: `岗位职责：
---1.根据研发部门的研发计划，设计和落实具体实验方案；
---2.负责真空镀膜生产线（洁净车间）的制程异常分析，提出并落实解决方案；
---3.负责研发新制程工艺与新材料，提升超导带材产品的性能与良率；
---4.协助部门同事共同推进相关研发工作；
---5.完成领导安排的其他研发工作。
---任职资格：
---1.硕士及以上学历，材料类、物理类等相关专业优先；
---2.具有超导材料研究、薄膜材料制备或真空镀膜相关经验者优先；
---3.长期稳定，热爱研发工作，能按照部门的研发计划开展研发工作；
---4.工作认真负责，有进取精神，具备良好的职业素养和敬业精神。`,
    },
  },
}; 